/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UIWidgetEnum } from './UIWidgetEnum';
import {
	UIWidgetEnumFromJSON,
	UIWidgetEnumFromJSONTyped,
	UIWidgetEnumToJSON,
} from './UIWidgetEnum';

/**
 * A property definition containing uiSchema values for the property
 * @export
 * @interface PropertyFromUISchema
 */
export interface PropertyFromUISchema {
	/**
	 *
	 * @type {UIWidgetEnum}
	 * @memberof PropertyFromUISchema
	 */
	uiwidget?: UIWidgetEnum;
}

/**
 * Check if a given object implements the PropertyFromUISchema interface.
 */
export function instanceOfPropertyFromUISchema(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function PropertyFromUISchemaFromJSON(json: any): PropertyFromUISchema {
	return PropertyFromUISchemaFromJSONTyped(json, false);
}

export function PropertyFromUISchemaFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PropertyFromUISchema {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		uiwidget: !exists(json, 'ui:widget')
			? undefined
			: UIWidgetEnumFromJSON(json['ui:widget']),
	};
}

export function PropertyFromUISchemaToJSON(value?: PropertyFromUISchema | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		'ui:widget': UIWidgetEnumToJSON(value.uiwidget),
	};
}
